<fr-header *ngIf="!isProduction"></fr-header>
<div class="app-content">
  <router-outlet></router-outlet>
</div>
